import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18 9v4H6V9H4v6h16V9h-2z"
}), 'SpaceBarOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SpaceBarOutlined.js
// module id = 6329
// module chunks = 2